import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, MediaUpload, InspectorControls, URLInput } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, Button, RangeControl, TextControl } from '@wordpress/components';
import { useSelect } from '@wordpress/data';

export default function Edit({ attributes, setAttributes }) {
    const { id_image_404Id, id_image_404Alt, id_image_404Opacite, id_image_404Afficher, id_titre_1Texte, id_titre_1CouleurTexte, id_titre_1Opacite, id_titre_1Afficher, id_paragraphe_1Texte, id_paragraphe_1CouleurTexte, id_paragraphe_1Opacite, id_paragraphe_1Afficher, id_bouton_retourTexte, id_bouton_retourUrl, id_bouton_retourCouleurFond, id_bouton_retourCouleurTexte, id_bouton_retourCouleurBordure, id_bouton_retourCouleurFondHover, id_bouton_retourCouleurTexteHover, id_bouton_retourCouleurBordureHover, id_bouton_retourCouleurFondActive, id_bouton_retourCouleurTexteActive, id_bouton_retourCouleurBordureActive, id_bouton_retourOpacite, id_bouton_retourAfficher, blocCouleurFond, blocCouleurBordure, blocImageFondId, animCode } = attributes;

    // Récupération dynamique et réactive des URLs avec useSelect
    const { imageUrl, id_image_404ImageUrl } = useSelect( ( select ) => {
        const media = select( 'core' );
        return {
            imageUrl: blocImageFondId ? media.getMedia( blocImageFondId )?.source_url : null,
            id_image_404ImageUrl: id_image_404Id ? media.getMedia( id_image_404Id )?.source_url : null
        };
    }, [ blocImageFondId, id_image_404Id ] );

    // Construire le style du bloc avec image de fond en priorité
    const blocStyle = imageUrl 
        ? { 
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderColor: blocCouleurBordure
        }
        : { 
            backgroundColor: blocCouleurFond, 
            borderColor: blocCouleurBordure 
        };

    const blockProps = useBlockProps({
        style: blocStyle
    });

    return (
        <>
            <style>{`
        .id_bouton_retour:hover {
            background-color: ${id_bouton_retourCouleurFondHover} !important;
            color: ${id_bouton_retourCouleurTexteHover} !important;
            border-color: ${id_bouton_retourCouleurBordureHover} !important;
        }
        .id_bouton_retour:active {
            background-color: ${id_bouton_retourCouleurFondActive} !important;
            color: ${id_bouton_retourCouleurTexteActive} !important;
            border-color: ${id_bouton_retourCouleurBordureActive} !important;
        }`}</style>
            {/* BARRE LATÉRALE (INSPECTOR) */}
            <InspectorControls>

                <PanelBody title="Bloc Principal" initialOpen={true}>
                    <BaseControl label="Image de fond">
                        <MediaUpload
                            onSelect={(media) => setAttributes({ blocImageFondId: media.id })}
                            type="image"
                            value={blocImageFondId}
                            render={({ open }) => (
                                <div>
                                    {imageUrl ? (
                                        <div>
                                            <img src={imageUrl} style={{ maxWidth: '100%', marginBottom: '10px' }} />
                                            <Button 
                                                variant="secondary" 
                                                isDestructive
                                                onClick={() => setAttributes({ blocImageFondId: 0 })}>
                                                Supprimer l'image
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button variant="primary" onClick={open}>
                                            Choisir une image de fond
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de fond (fallback)" help="Utilisée si aucune image n'est définie">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>
                <PanelBody title="image-404 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_image_404Afficher}
                        onChange={(val) => setAttributes({ id_image_404Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_image_404Alt}
                            onChange={(val) => setAttributes({ id_image_404Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_image_404Opacite}
                        onChange={(val) => setAttributes({ id_image_404Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="bouton-retour (Bouton)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_bouton_retourAfficher}
                        onChange={(val) => setAttributes({ id_bouton_retourAfficher: val })}
                    />
                    <BaseControl label="URL du bouton">
                        <URLInput
                            value={id_bouton_retourUrl}
                            onChange={(url) => setAttributes({ id_bouton_retourUrl: url })}
                            isFullWidth
                        />
                    </BaseControl>
                    
                    <h4>État Normal</h4>
                    <BaseControl label="Couleur de fond">
                        <ColorPalette value={id_bouton_retourCouleurFond} onChange={(val) => setAttributes({ id_bouton_retourCouleurFond: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte">
                        <ColorPalette value={id_bouton_retourCouleurTexte} onChange={(val) => setAttributes({ id_bouton_retourCouleurTexte: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette value={id_bouton_retourCouleurBordure} onChange={(val) => setAttributes({ id_bouton_retourCouleurBordure: val })} />
                    </BaseControl>
                    
                    <h4>État Hover</h4>
                    <BaseControl label="Couleur de fond (Hover)">
                        <ColorPalette value={id_bouton_retourCouleurFondHover} onChange={(val) => setAttributes({ id_bouton_retourCouleurFondHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Hover)">
                        <ColorPalette value={id_bouton_retourCouleurTexteHover} onChange={(val) => setAttributes({ id_bouton_retourCouleurTexteHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Hover)">
                        <ColorPalette value={id_bouton_retourCouleurBordureHover} onChange={(val) => setAttributes({ id_bouton_retourCouleurBordureHover: val })} />
                    </BaseControl>
                    
                    <h4>État Active</h4>
                    <BaseControl label="Couleur de fond (Active)">
                        <ColorPalette value={id_bouton_retourCouleurFondActive} onChange={(val) => setAttributes({ id_bouton_retourCouleurFondActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Active)">
                        <ColorPalette value={id_bouton_retourCouleurTexteActive} onChange={(val) => setAttributes({ id_bouton_retourCouleurTexteActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Active)">
                        <ColorPalette value={id_bouton_retourCouleurBordureActive} onChange={(val) => setAttributes({ id_bouton_retourCouleurBordureActive: val })} />
                    </BaseControl>
                    
                    <RangeControl
                        label="Opacité"
                        value={id_bouton_retourOpacite}
                        onChange={(val) => setAttributes({ id_bouton_retourOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Animations" initialOpen={false}>
                    <BaseControl 
                        label="Code d'animation" 
                        help="JavaScript exécuté">
                        <textarea
                            value={animCode}
                            onChange={(e) => setAttributes({ animCode: e.target.value })}
                            placeholder="Mon animation ici..."
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                        />
                    </BaseControl>
                </PanelBody>
            </InspectorControls>

            {/* VISUEL PRINCIPAL */}
            <section { ...blockProps }>
                <div className="container"></div>
            </section>
        </>
    );
}